import axios, { AxiosInstance } from "axios";

export const BaseURL: AxiosInstance = axios.create({
  baseURL: "https://vaspayapi.v2nportal.com/api/v1",
  validateStatus: (status: number): boolean => {
    return status >= 200 && status < 500;
  },
});
